import type { ComponentPropsWithRef, JSX } from 'react';

import { memo } from '@change-corgi/core/react/core';
import { parseHtml } from '@change-corgi/core/react/html';
import { Box } from '@change-corgi/design-system-legacy/layout';
import type { ResponsiveValue } from '@change-corgi/design-system-legacy/theme';

type Props = Omit<ComponentPropsWithRef<typeof Box>, 'variant'> & {
	aspectRatio?: ResponsiveValue<string>;
	embedHtml: string;
};

export const EmbeddedVideo = memo(
	({
		embedHtml,
		aspectRatio,
		sx,
		ref,
		...rest
	}: Props & {
		ref?: React.RefObject<HTMLTextAreaElement>;
	}): JSX.Element => {
		return (
			<Box
				sx={{
					aspectRatio,
					overflow: 'hidden',
					'& iframe, & embed, & object, & video': {
						height: '100%',
						width: '100%',
					},
					// eslint-disable-next-line @typescript-eslint/no-misused-spread
					...sx, // only required for storybook to take overrides into account
				}}
				{...rest}
				ref={ref}
			>
				{parseHtml(embedHtml, {
					allowedTags: ['iframe'],
					allowedAttrs: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
				})}
			</Box>
		);
	},
);
